<div class="modal-header">
  <h4 class="modal-title" id="popup-title" i18n>Select Date Time</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" >
  <div class="mx-auto">
    <ngb-datepicker [(ngModel)]="model" (select)="onDateSelection($event)"></ngb-datepicker>
    <ngb-timepicker [meridian]="true" [(ngModel)]="timeModel" (ngModelChange)="onTimeSelection($event)"></ngb-timepicker>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close({date: model, time: timeModel})" i18n>Apply Date Time</button>
</div>
